import { useDisclosure, useLocalStorage } from "@mantine/hooks";
import { useState } from "react";

import { DISCLAIMER_MODAL_KEYS } from "#shared/constants";
import { MaterialGradeType } from "shared";

export const useMaterialChangeDisclaimerModal = () => {
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const [dontShowAgain, setDontShowAgain] = useLocalStorage({
    key: DISCLAIMER_MODAL_KEYS.MATERIAL_CHANGE,
    defaultValue: false,
  });
  const [pendingMaterial, setPendingMaterial] = useState<{
    materialName: string;
    materialGrade: MaterialGradeType | null;
  } | null>(null);

  const checkboxProps = {
    id: DISCLAIMER_MODAL_KEYS.MATERIAL_CHANGE,
    checked: dontShowAgain,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => setDontShowAgain(e.currentTarget.checked),
  };

  const handleConfirm = (
    onConfirm: (materialName: string, materialGrade: MaterialGradeType | null) => void,
  ) => {
    if (pendingMaterial) {
      onConfirm(pendingMaterial.materialName, pendingMaterial.materialGrade);
    }
    closeModal();
    setPendingMaterial(null);
  };

  const handleCancel = () => {
    closeModal();
    setPendingMaterial(null);
  };

  const showModalOrConfirm = ({
    materialGrade,
    materialName,
    onConfirm,
    shouldShowModal,
  }: {
    materialName: string;
    materialGrade: MaterialGradeType | null;
    onConfirm: (materialName: string, materialGrade: MaterialGradeType | null) => void;
    shouldShowModal: boolean;
  }) => {
    if (!shouldShowModal || dontShowAgain) {
      onConfirm(materialName, materialGrade);
      return;
    }

    setPendingMaterial({ materialName, materialGrade });
    openModal();
  };

  return {
    modalOpened,
    openModal,
    closeModal,
    handleConfirm,
    handleCancel,
    checkboxProps,
    showModalOrConfirm,
  };
};
